<template>
  <div class="panel">
    <disclamer-modal></disclamer-modal>
    <status-modal></status-modal>
    <RegisterCubeModal :shopid="shopid"></RegisterCubeModal>
    <actions-modal :cube="cube" :cubes="actionCubes"></actions-modal>
      <div class="panel-heading">
          <div class="panel-label">
            <h3>Cubes</h3>
          </div>
          <div class="panel-toolbar">
              <Guard :hideFor="['admin', 'key_account', 'shop_owner']">
                <button class="btn btn-danger btn-sm" @click="openRegisterCube">Register Cube</button>
              </Guard>
          </div>
      </div>
      <div class="panel-body">
        <vue-table class="products-table" ref="table" :tableFields="TableFields" :dataTable="selectedCubes" :slots="slots" :onRowClass="onRowClass">
          <template slot="select" slot-scope="props">
              <input type="checkbox" v-model="selected[props.data.name]">
          </template>
          <template slot="name" slot-scope="props">
              <span>{{props.data.name}}</span>
          </template>
          <template slot="teamviewer" slot-scope="props">
              <span>{{props.data.original.teamviewer}}</span>
          </template>
          <template slot="crc" slot-scope="props">
              <span>{{props.data.original.crc}}</span>
          </template>
          <template slot="wifi" slot-scope="props">
              <span :class="{'wifi': props.data.original.wifi }">{{props.data.original.wifi?"ON":props.data.original.wifi===false?"OFF":"UPDATE INSTALLER"}}</span>
          </template>
          <template slot="status" slot-scope="props">
              <button class="btn btn-primary btn-sm" @click="showStatusModal(props.data)">Status</button>
          </template>
          <template slot="actions" slot-scope="props">
              <button class="btn btn-danger btn-sm" @click="openActions(props.data)">Actions</button>
          </template>
        </vue-table>
      </div>
      <div class="panel-footer">
        <div class="box">
            <button class="btn btn-success" @click="showDisclamerModal">SELECTED ACTIONS</button>
        </div>
      </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DisclamerModal from './modals/disclamer';
import ActionsModal from './modals/actions';
import StatusModal from './modals/status';
import RegisterCubeModal from './modals/registerCube';
import Table from '../Table/Table';
export default {
    name: 'cubes',
    props: {
        shopid: {
            type: String
        }
    },
    components: {
        DisclamerModal,
        ActionsModal,
        StatusModal,
        'vue-table': Table,
        RegisterCubeModal
    },
    data (){
        return {
            selected: {},
            selectedCubes: [],
            cube: undefined,
            actionCubes: [],
            TableFields: [
                {
                    name: 'select',
                    title: 'Select',
                    sortField: 'formatDisplayString',
                    propName: 'formatDisplayString'
                },
                {
                    name: 'name',
                    title: 'Name',
                    sortField: 'formatDisplayString',
                    propName: 'formatDisplayString'
                },
                {
                    name: 'teamviewer',
                    title: 'Teamviewer',
                    sortField: 'type',
                    propName: 'type'
                },
                {
                    name: 'crc',
                    title: 'Code crc',
                    sortField: 'code',
                    propName: 'code'
                },
                {
                    name: 'wifi',
                    title: 'Wifi',
                    sortField: 'wifi',
                    propName: 'wifi'
                },
                {
                    name: 'status',
                    title: 'Status',
                    sortField: 'status',
                    propName: 'status'
                },
                {
                    name: 'actions',
                    title: 'Actions',
                    sortField: 'code',
                    propName: 'code'
                }
            ],
            slots: [
                {
                    name: 'select'
                },
                {
                    name: 'name'
                },
                {
                    name: 'teamviewer'
                },
                {
                    name: 'crc'
                },
                {
                    name: 'status'
                },
                {
                    name: 'wifi'
                },
                {
                    name: 'actions'
                }
            ]
        };
    },
    computed:{
        ...mapGetters({
            cubes: 'getCubes'
        })
    },
    watch:{
        cubes (newlist){
            if(this.shopid && this.cubes){
                this.selectedCubes = this.cubes[this.shopid]?.list || [];
            }
        },
        shopid (nv, ov){
            if(this.shopid && this.cubes && this.cubes[this.shopid]){
                this.selectedCubes = this.cubes[this.shopid].list;
            }
        }
    },
    methods:{
        ...mapActions([
            'setLoggingRegisterCube',
        ]),
        openActions (cube){
            this.cube = cube;
            this.$modal.show('disclamer');
        },
        showStatusModal (cube) {
            //console.log('showStatusModal', cube.original);
            //console.log('showStatusModal', typeof cube.original.wifi);
            const { name:cubename = undefined } = cube;
            this.cube = cube;
            this.$modal.show('status', { cubename });
        },
        showDisclamerModal (){
            this.actionCubes = [];
            for(const cube in this.selected){
                if(this.selected[cube]){
                    this.actionCubes.push(cube);
                }
            }
            this.$modal.show('disclamer');
        },
        openRegisterCube(){
            this.$modal.show('registercube')
        },
        onRowClass(dataItem, index){
            return dataItem.original.registredFlag ? "" : "unregistred";
        }
    },
    mounted (){
        if(this.shopid && this.cubes[this.shopid]){
            this.selectedCubes = this.cubes[this.shopid].list;
        }
    }
};
</script>

<style lang="scss" scoped>
  .cube{
    background-color: #000;
  }
</style>
